<template lang="pug">
.file-list
  van-checkbox-group(ref="container", v-model="checkedIds")
    van-swipe-cell.cell-item(v-for="(file, index) in showList", ref="swipe", :key="file.fileId", :disabled="showSelection")
      .file-item(@click="clickFileItemHandler(file, index, $event)")
        .file-tools
          transition(name="van-slide-left")
            van-checkbox.mx-gap(v-if="showSelection", :name="file.fileId", ref="checkboxes", icon-size="18")
        FileIcon(:row="file", :icon-size="24", readonly)
        .file-info
          FileName(:class="{ 'target-err': !file.targetFolderPath }", :name="file.fileName")
          .file-size {{ file.fileSize | fileSize }}
      template(#left)
        van-button(square, type="primary", text="选择", @click="h5DoSelection(file)")
      template(#right, v-if="file.$delete")
        van-button(square, type="danger", text="删除", @click="h5DeleteFile(file, showList, index)")
  van-action-sheet(v-model="h5ShowFileActionSheet", :actions="h5FileActions", cancel-text="关闭", description="文件操作", close-on-click-action, @select="onH5ActionSelect")
</template>
<script>
import FileName from "@/CommonDP/components/FileList/fileName.vue";
import docFileTable from "@/CommonDP/components/FileList/docFileTable.vue";
export default {
  components: { FileName },
  extends: docFileTable,
  props: {
    showSelection: { default: false, type: Boolean },
    h5FileSheet: { default: undefined, type: Function }
  },
  data() {
    return {
      h5FileActions: [],
      h5File: undefined,
      h5ShowFileActionSheet: false
    };
  },
  created() {
    // 只针对当前组件
    this.$confirm = (message, title) => this.$dialog.confirm({ title, message });
  },
  methods: {
    h5DoSelection(file) {
      this.$emit("update:showSelection", true);
      const list = [];
      file && list.push(file.fileId);
      this.checkedIds = list;
    },
    async onH5ActionSelect(item) {
      await item.handler(this.h5File, this.showList);
      this.h5ShowFileActionSheet = false;
    },
    async h5DeleteFile(file, showList) {
      this.deleteFile(file, showList);
    },
    async openH5FileActionSheet(row) {
      const { h5FileSheet: getSheet } = this;
      let sheets = [{ name: "预览", handler: this.previewFn }];
      if (row.$delete) sheets.push({ name: "删除", handler: this.deleteFile });
      if (row.$url) sheets.push({ name: "下载", handler: this.downloadHandler });
      if (getSheet) sheets = await getSheet(row, sheets);
      this.h5FileActions = sheets;
      this.h5ShowFileActionSheet = true;
    },
    h5ToggleChecked(row, index) {
      this.h5File = row;
      if (this.showSelection) {
        this.$refs.checkboxes[index].toggle();
      } else {
        this.openH5FileActionSheet(row, index);
      }
    },
    clickFileItemHandler(row, index) {
      this.h5ToggleChecked(row, index);
    }
  }
};
</script>
<style lang="scss" scoped src="./list.scss">
</style>
